module.exports = __webpack_public_path__ + "static/media/(H)_MG_5770-bijuterias-acessorios.bda91027.jpg";